export const professionOptions = [
  // --- التعليم ---
  { value: "معلم", label: "معلم" },
  { value: "مدرس", label: "مدرس" },
  { value: "مدرسة", label: "مدرسة" },
  { value: "أستاذ جامعي", label: "أستاذ جامعي" },
  { value: "طالب", label: "طالب" },
  { value: "طالبة", label: "طالبة" },

  // --- القطاع الصحي ---
  { value: "طبيب", label: "طبيب" },
  { value: "طبيبة", label: "طبيبة" },
  { value: "دكتور", label: "دكتور" },
  { value: "دكتورة", label: "دكتورة" },
  { value: "ممرض", label: "ممرض" },
  { value: "ممرضة", label: "ممرضة" },
  { value: "صيدلي", label: "صيدلي" },
  { value: "فني مخبري", label: "فني مخبري" },

  // --- القطاع الحكومي والأمني ---
  { value: "موظف حكومي", label: "موظف حكومي" },
  { value: "شرطي", label: "شرطي" },
  { value: "عسكري", label: "عسكري" },
  { value: "محامي", label: "محامي" },
  { value: "قاضٍ", label: "قاضٍ" },

  // --- المهن الفنية والحرفية ---
  { value: "عامل", label: "عامل" },
  { value: "سائق", label: "سائق" },
  { value: "نجار", label: "نجار" },
  { value: "حداد", label: "حداد" },
  { value: "كهربائي", label: "كهربائي" },
  { value: "ميكانيكي", label: "ميكانيكي" },
  { value: "بناء", label: "بناء" },
  { value: "سباك", label: "سباك" },

  // --- المهن الحرة ---
  { value: "مهندس", label: "مهندس" },
  { value: "مهندسة", label: "مهندسة" },

  { value: "مقاول", label: "مقاول" },
  { value: "تاجر", label: "تاجر" },
  { value: "صاحب عمل", label: "صاحب عمل" },
  { value: "مغترب", label: "مغترب" },

  // --- الزراعة والحرف التقليدية ---
  { value: "مزارع", label: "مزارع" },
  { value: "راعٍ", label: "راعٍ" },
  { value: "حرفي", label: "حرفي" },
  { value: "ملاك", label: "ملاك" },

  // --- أخرى ---
  { value: "ربة منزل", label: "ربة منزل" },
  { value: "متقاعد", label: "متقاعد" },
  { value: "متقاعدة", label: "متقاعدة" },
  { value: "لا تعمل", label: "لا تعمل" },
  { value: "لا يعمل", label: "لا يعمل" },
  { value: "أخرى", label: "أخرى" },
];

export const fuelType = [
  { value: "بنزين", label: "بنزين" },
  { value: "ديزل", label: "ديزل" },
  { value: "كهرباء", label: "كهرباء" },
];

export const healthOptions = [
  { value: "جيدة", label: "جيدة" },
  { value: "أمراض خبيثة", label: "أمراض خبيثة" },
  { value: "مريض قلب", label: "مريض قلب" },
  { value: "إعاقة", label: "إعاقة" },
  { value: "مريض غسيل كلى", label: "مريض غسيل كلى" },
  { value: "أمراض كلى", label: "أمراض كلى" },
  { value: "مريض عجزة", label: "مريض عجزة" },
  { value: "مرض مزمن", label: "مرض مزمن" },
  { value: "مرضع", label: "مرضع" },
  { value: "متوفى", label: "متوفى" },
  { value: "متوفاة", label: "متوفاة" },
];
export const eduOptions = [
  // --- الطفولة والمراحل المبكرة ---
  { value: "حديث الولادة", label: "حديث الولادة" },
  { value: "لم يبدأ الدراسة", label: "لم يبدأ الدراسة" },
  { value: "لم تبدأ الدراسة", label: "لم تبدأ الدراسة" },

  { value: "روضة", label: "روضة" },

  // --- التعليم الأساسي ---
  { value: "ابتدائي", label: "ابتدائي" },
  { value: "إعدادي", label: "إعدادي" },
  { value: "ثانوي", label: "ثانوي" },

  // --- التعليم المهني والتقني ---
  { value: "معهد مهني", label: "معهد مهني" },
  { value: "معهد", label: "معهد" },

  { value: "دبلوم متوسط", label: "دبلوم متوسط" },

  // --- التعليم العالي ---
  { value: "جامعي", label: "جامعي" },
  { value: "جامعية", label: "جامعية" },

  { value: "دراسات عليا", label: "دراسات عليا" },
  { value: "ماجستير", label: "ماجستير" },
  { value: "دكتوراه", label: "دكتوراه" },

  // --- أخرى ---
  { value: "غير متعلم", label: "غير متعلم" },
  { value: "غير متعلمة", label: "غير متعلمة" },
  { value: "أمي", label: "أمي" },

  { value: "أمية", label: "أمية" },
  { value: "غير محدد", label: "غير محدد" },
  { value: "أخرى", label: "أخرى" },
];

export const swidaVillagesFull = [
  { value: "حبران", label: "حبران" },
  { value: "السويداء", label: "السويداء" },
  { value: "دمشق", label: "دمشق" },
  { value: "جرمانا", label: "جرمانا" },
  { value: "سليم", label: "سليم" },
  { value: "عتيل", label: "عتيل" },
  { value: "قنوات", label: "قنوات" },
  { value: "مفعلة", label: "مفعلة" },
  { value: "بريكة", label: "بريكة" },
  { value: "مردك", label: "مردك" },
  { value: "شهبا", label: "شهبا" },
  { value: "أم الزيتون", label: "أم الزيتون" },
  { value: "السويمرة", label: "السويمرة" },
  { value: "المتونة", label: "المتونة" },
  { value: "لاهثة", label: "لاهثة" },
  { value: "الهيت", label: "الهيت" },
  { value: "الهيات", label: "الهيات" },
  { value: "البثينة", label: "البثينة" },
  { value: "تعلا", label: "تعلا" },
  { value: "عمرة", label: "عمرة" },
  { value: "الحقف", label: "الحقف" },
  { value: "الخالدية", label: "الخالدية" },
  { value: "السالمية", label: "السالمية" },
  { value: "الرضيمة", label: "الرضيمة" },
  { value: "الصورة الصغيرة", label: "الصورة الصغيرة" },
  { value: "الصورة الكبيرة", label: "الصورة الكبيرة" },
  { value: "خلخلة", label: "خلخلة" },
  { value: "حزم", label: "حزم" },
  { value: "أم حارتين", label: "أم حارتين" },
  { value: "ذكير", label: "ذكير" },
  { value: "شقا", label: "شقا" },
  { value: "الجنينة", label: "الجنينة" },
  { value: "تيما", label: "تيما" },
  { value: "بارك", label: "بارك" },
  { value: "نمرة", label: "نمرة" },
  { value: "الغيضة", label: "الغيضة" },
  { value: "نجران", label: "نجران" },
  { value: "عريقة", label: "عريقة" },
  { value: "الخرسا", label: "الخرسا" },
  { value: "داما", label: "داما" },
  { value: "صميد", label: "صميد" },
  { value: "مجادل", label: "مجادل" },
  { value: "المزرعة", label: "المزرعة" },
  { value: "المجدل", label: "المجدل" },
  { value: "ريمة اللحف", label: "ريمة اللحف" },
  { value: "جديا", label: "جديا" },
  { value: "صلاخد", label: "صلاخد" },
  { value: "كفر اللحف", label: "كفر اللحف" },
  { value: "جدل", label: "جدل" },
  { value: "ولغا", label: "ولغا" },
  { value: "الدور", label: "الدور" },
  { value: "تعارة", label: "تعارة" },
  { value: "سميع", label: "سميع" },
  { value: "قراصة", label: "قراصة" },
  { value: "لبين", label: "لبين" },
  { value: "جرين", label: "جرين" },
  { value: "حران", label: "حران" },
  { value: "صما الهنيدات", label: "صما الهنيدات" },
  { value: "الطيرة", label: "الطيرة" },
  { value: "الثعلة", label: "الثعلة" },
  { value: "سكاكا", label: "سكاكا" },
  { value: "الدارة", label: "الدارة" },
  { value: "الاصلحة", label: "الاصلحة" },
  { value: "كناكر", label: "كناكر" },
  { value: "خربة أم العلق", label: "خربة أم العلق" },
  { value: "الدويرة", label: "الدويرة" },
  { value: "ريمة حازم", label: "ريمة حازم" },
  { value: "مصاد", label: "مصاد" },
  { value: "الرحى", label: "الرحى" },
  { value: "الكفر", label: "الكفر" },
  { value: "خربة كويرس", label: "خربة كويرس" },
  { value: "سهوة بلاطة", label: "سهوة بلاطة" },
  { value: "رساس", label: "رساس" },
  { value: "العفينة", label: "العفينة" },
  { value: "عرى", label: "عرى" },
  { value: "المجيمر", label: "المجيمر" },
  { value: "خربا", label: "خربا" },
  { value: "أم الرمان", label: "أم الرمان" },
  { value: "الغارية", label: "الغارية" },
  { value: "عنز", label: "عنز" },
  { value: "المغير", label: "المغير" },
  { value: "خربة عواد", label: "خربة عواد" },
  { value: "العانات", label: "العانات" },
  { value: "المشقوق", label: "المشقوق" },
  { value: "الرافقة", label: "الرافقة" },
  { value: "المنذرة", label: "المنذرة" },
  { value: "خربة العليقة", label: "خربة العليقة" },
  { value: "أم رواق", label: "أم رواق" },
  { value: "الطيبة", label: "الطيبة" },
  { value: "طربا", label: "طربا" },
  { value: "العجيلات", label: "العجيلات" },
  { value: "عرمان", label: "عرمان" },
  { value: "صلخد", label: "صلخد" },
  { value: "شنيرة", label: "شنيرة" },
  { value: "مجدل الشور", label: "مجدل الشور" },
  { value: "صما البردان", label: "صما البردان" },
  { value: "أمضان", label: "أمضان" },
  { value: "خازمة", label: "خازمة" },
  { value: "ملح", label: "ملح" },
  { value: "سهوة الخضر", label: "سهوة الخضر" },
  { value: "مياماس", label: "مياماس" },
  { value: "رامي", label: "رامي" },
  { value: "أم ضبيب", label: "أم ضبيب" },
  { value: "عراجة", label: "عراجة" },
  { value: "دوما", label: "دوما" },
  { value: "الرضيمة الشرقية", label: "الرضيمة الشرقية" },
  { value: "الشريحي", label: "الشريحي" },
  { value: "بهم", label: "بهم" },
  { value: "تحولا", label: "تحولا" },
  { value: "المشنف", label: "المشنف" },
  { value: "الحريسة", label: "الحريسة" },
  { value: "تل اللوز", label: "تل اللوز" },
  { value: "طللين", label: "طللين" },
  { value: "أبو زريق", label: "أبو زريق" },
  { value: "سالي", label: "سالي" },
  { value: "شعف", label: "شعف" },
  { value: "الرشيدة", label: "الرشيدة" },
  { value: "الكسيب", label: "الكسيب" },
  { value: "بوسان", label: "بوسان" },
  { value: "الهويا", label: "الهويا" },
  { value: "الشبكي", label: "الشبكي" },
  { value: "اسعنا", label: "اسعنا" },
  { value: "قيصما", label: "قيصما" },
  { value: "شبكي", label: "شبكي" },
  { value: "الإمارات", label: "الإمارات" },
  { value: "قطر", label: "قطر" },
  { value: "السعودية", label: "السعودية" },
  { value: "الكويت", label: "الكويت" },
  { value: "البحرين", label: "البحرين" },
  { value: "مصر", label: "مصر" },
  { value: "عمان", label: "عمان" },
  { value: "الأردن", label: "الأردن" },
  { value: "فلسطين", label: "فلسطين" },
  { value: "أوروبا", label: "أوروبا" },
  { value: "أمريكا", label: "أمريكا" },
  { value: "أستراليا", label: "أستراليا" },
  { value: "أوكرانيا", label: "أوكرانيا" },
  { value: "غير ذلك", label: "غير ذلك" },
];

export const carTypeOptions = [
  { value: "سيارة", label: "سيارة" },
  { value: "شاحنة", label: "شاحنة" },
  { value: "باص", label: "باص" },
  { value: "سرفيس", label: "سرفيس" },
  { value: "جرار", label: "جرار" },
  { value: "آلية ثقيلة", label: "آلية ثقيلة" },
  { value: "دراجة نارية", label: "دراجة نارية" },
  { value: "other", label: "أخرى" },
];

export const cronTypeOptions = [
  { value: "صليخ", label: "صليخ" },
  { value: "عنب", label: "عنب" },
  { value: "تفاح", label: "تفاح" },
  { value: "تفاح - عنب", label: "تفاح - عنب" },
  { value: "زيتون", label: "زيتون" },
  { value: "جوز", label: "جوز" },
  { value: "زيتون - تفاح - عنب", label: "زيتون - تفاح - عنب" },
  { value: "أكثر من نوع", label: "أكثر من نوع" },
  { value: "لوزيات", label: "لوزيات" },
  { value: "زرع وفلح", label: "زرع وفلح" },
  { value: "غير مستصلح", label: "غير مستصلح" },
];

export const materialStatusOptions = [
  { value: "مطلق", label: "مطلق" },
  { value: "متزوج", label: "متزوج" },
  { value: "متزوجة", label: "متزوجة" },
  { value: "أعزب", label: "أعزب" },
  { value: "عزباء", label: "عزباء" },
  { value: "أرمل", label: "أرمل" },
  { value: "مطلقة", label: "مطلقة" },
  { value: "أرملة", label: "أرملة" },
];
export const familyStatusOptions = [
  { value: "وافد داخلي", label: "وافد داخلي" },
  { value: "متضرر", label: "متضرر" },
  { value: "عائد", label: "عائد" },
];

export const homeTypeOptions = [
  { value: "ملك", label: "ملك" },
  { value: "آجار", label: "آجار" },
  { value: "استضافة", label: "استضافة" },
  { value: "هبة", label: "هبة" },
];

export const homeStatusOptions = [
  { value: "بيت عربي", label: "بيت عربي" },
  { value: "شقة", label: "شقة" },
  { value: "أبنية فارغة", label: "أبنية فارغة" },
  { value: "مركز إيواء", label: "مركز إيواء" },
  { value: "مكتب", label: "مكتب" },
  { value: "خيمة", label: "خيمة" },
  { value: "مزرعة", label: "مزرعة" },
];
export const homeStatus2Options = [
  { value: "مكسي  ", label: "مكسي" },
  { value: "غير مكسي", label: "غير مكسي" },
];
